import React from 'react';

import { faCog } from '@rtkwlf/pro-solid-svg-icons/faCog';
import { useTranslation } from 'react-i18next';

import { IconDropdownMenu } from '../icon-dropdown-menu';

import { ThemeSwitchMenuItem } from './theme-switch-menu-item';
import { TimezoneSwitchMenuItem } from './timezone-switch-menu-item';

export const SettingsMenu: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslation();

  return (
    <IconDropdownMenu
      title={t('appBar:settings')}
      icon={faCog}
      iconLabel={t('appBar:settingsMenu.tooltip')}
    >
      <ThemeSwitchMenuItem />
      <TimezoneSwitchMenuItem />
      {children}
    </IconDropdownMenu>
  );
};
